<template>
  <v-card>
    <v-divider></v-divider>
    <v-card-title primary-title>
      <div>
        <h5 class="title mb-0">Recebimento na empresa (Pós-Pago)</h5>
      </div>
    </v-card-title>
    <v-divider></v-divider>
    <v-flex>
      <v-data-table
        :headers="headers"
        :items="itemsToShow"
        :hide-default-header="!itemsToShow.length"
        hide-default-footer
        :loading="isLoading"
        class="elevation-1"
      >
        <template v-slot:item="props">
          <tr :key="props.item.id_tipo_pagamento">
            <td style="width: 10px">
              <v-switch
                color="success"
                :input-value="props.item.aceito"
                @change="val => onToggle(props.item, val)"
              />
            </td>
            <td class="text-xs-left">{{ props.item.descricao }}</td>
          </tr>
        </template>

        <template v-slot:no-data>
          <v-layout justify-center class="pa-4 grey--text">
            Nenhum método pós-pago configurado.
          </v-layout>
        </template>
      </v-data-table>
    </v-flex>
  </v-card>
</template>

<script>
export default {
  name: 'SelectMetodosPospago',
  data () {
    return {
      headers: [
        { text: '', value: 'toggle', sortable: false, align: 'left', width: 10 },
        { text: 'Descrição', value: 'descricao', sortable: false, align: 'left' }
      ],
      aceitos: {},
      listaTiposEmpresa: []
    }
  },
  computed: {
    isLoading () {
      return this.loading || this.$store.getters.loading
    },
    tiposPagamentoStore () {
      return this.$store.getters.tipos_pagamento || []
    },
    empresa () {
      return this.$store.getters.empresa
    },
    itemsToShow () {
      const base = (this.tiposPagamentoPos && this.tiposPagamentoPos.length)
        ? this.tiposPagamentoPos
        : this.tiposPagamentoStore
      const mapEmpresa = {}
      this.listaTiposEmpresa.forEach(t => { mapEmpresa[t.referencia] = t.aceito })
      const final = base.map(b => ({
        id_tipo_pagamento: b.id_tipo_pagamento,
        descricao: b.descricao,
        referencia: b.referencia,
        aceito: mapEmpresa[b.referencia] === undefined ? !!this.aceitos[b.id_tipo_pagamento] : mapEmpresa[b.referencia]
      }))
      this.ensureAceitos(final)
      return final
    }
  },
  methods: {
    ensureAceitos (lista) {
      if (!Array.isArray(lista)) return
      lista.forEach(item => {
        const id = item.id_tipo_pagamento
        const ref = item.referencia
        const chave = id != null ? id : ref
        if (chave == null) return
        if (this.aceitos[chave] === undefined) {
          const valor = item.aceito !== undefined
            ? !!item.aceito
            : (id != null ? !!this.valores[id] : !!this.valores[ref])
          this.$set(this.aceitos, chave, valor)
        }
      })
    },
    onToggle (item, value) {
      const id = item.id_tipo_pagamento
      const ref = item.referencia
      const chave = id != null ? id : ref
      this.$set(this.aceitos, chave, !!value)
      this.$emit('toggle', {
        id_tipo_pagamento: id,
        referencia: ref,
        value: !!value
      })
      if (this.empresa && ref) {
        this.$store.dispatch('permitirTipoPagamentoPosPago', { empresa: this.empresa.cnpj, referencia: ref })
          .then(() => {
            this.loadEmpresaTipos()
          })
          .catch(() => {
            this.$set(this.aceitos, chave, !value)
          })
      }
    },
    carregarTiposGerais () {
      this.$store.dispatch('carregarTiposPagamento').catch(() => {})
    },
    loadEmpresaTipos () {
      if (!this.empresa) return
      this.$store.dispatch('tipospagamentoEmpresa', this.empresa.cnpj)
        .then(lista => {
          this.listaTiposEmpresa = Array.isArray(lista) ? lista : []
          this.listaTiposEmpresa.forEach(item => {
            this.$set(this.aceitos, item.referencia, !!item.aceito)
          })
        })
        .catch(() => {})
    }
  },
  created () {
    this.carregarTiposGerais()
    this.loadEmpresaTipos()
  },
  watch: {
    tiposPagamentoStore (nv) {
      this.ensureAceitos(nv)
    },
    tiposPagamentoPos (nv) {
      this.ensureAceitos(nv)
    },
    empresa (val) {
      if (val) {
        this.loadEmpresaTipos()
      }
    },
    valores: {
      handler (nv) {
        Object.keys(nv || {}).forEach(k => {
          this.$set(this.aceitos, Number(k), !!nv[k])
        })
      },
      deep: true
    }
  }
}
</script>
